import { EventFileIcon } from '../../../../../assets/img/logo/EventFile'
import { ProgramFileIcon } from '../../../../../assets/img/logo/ProgramFile'
import { FileItem, STitle, SWrapper } from '../components.styled'

const userGuide = '/docs/rostov/user-guide-test.pdf'
const linkProgramFile = '/docs/rostov/program-enrollment-test.pdf'

export const ForParent = () => (
  <SWrapper>
    Инструкции для родителей
    <FileItem href={linkProgramFile}>
      <ProgramFileIcon />
      <STitle>Как записаться на программу</STitle>
    </FileItem>
    <FileItem href={userGuide} target="_blank" rel="noreferrer">
      <EventFileIcon />
      <STitle>Руководство пользователя</STitle>
    </FileItem>
  </SWrapper>
)
